import React from 'react';
import { Select } from 'antd';
import { useLazyQuery, useQuery } from '@apollo/client';
import {
  GET_ALL_CHANNEL,
  SEARCH_CHANNELS_BY_NAME,
  allChannelResponse,
  SearchChannelsByNameResponse
} from '../../../../../graphql/queries/getChannelAll';

interface ClientSelectWrapperProps {
  value?: number;
  onChange?: (value: number | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
}

function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = React.useState(value);
  React.useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}

export const ClientSelectWrapper: React.FC<ClientSelectWrapperProps> = ({
  value,
  onChange,
  placeholder = '选择客户',
  disabled = false
}) => {
  const { data: allData, loading: allLoading } = useQuery<allChannelResponse>(GET_ALL_CHANNEL);
  const [search, { data: searchData, loading: searchLoading }] = useLazyQuery<SearchChannelsByNameResponse>(SEARCH_CHANNELS_BY_NAME);

  const [searchText, setSearchText] = React.useState('');
  const debouncedKeyword = useDebounce(searchText, 300);

  React.useEffect(() => {
    if (debouncedKeyword && debouncedKeyword.trim().length > 0) {
      search({ variables: { keyword: debouncedKeyword.trim() } });
    }
  }, [debouncedKeyword, search]);

  const options = React.useMemo(() => {
    const list = (debouncedKeyword && searchData?.searchChannelsByName?.length)
      ? searchData.searchChannelsByName
      : allData?.getAllChannels || [];

    return list.map(ch => ({
      label: `${ch.channelName} (ID: ${ch.id})`,
      value: ch.id,
      searchText: `${ch.channelName} ${ch.id}`
    }));
  }, [allData, searchData, debouncedKeyword]);

  const handleChange = (val: number | null) => {
    if (onChange) {
      onChange(val !== null ? val : undefined);
    }
  };

  return (
    <Select
      showSearch
      allowClear
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      loading={allLoading || searchLoading}
      options={options}
      filterOption={false}
      onSearch={(val) => setSearchText(val)}
      className="w-full"
      disabled={disabled}
    />
  );
};

export default ClientSelectWrapper;

